<template>
  <b-container>
    <h2>Auroras.live Help</h2>
    <p>Auroras.live is set of websites, phone apps, smart watch apps and developer tools designed to help astrophotographers and night sky enthusiasts see the northern or southern lights</p>
    <h2>How does this site work?</h2>
    <p>The site offers several easy to read color coded metrics that let you see at a glance what conditions are like in the night sky.</p>
    <p>It does this by reading real time conditions from various satellites and ground stations around the world, and displaying in the form of gauges, charts and so forth</p>
  </b-container>
</template>

<script>

  export default {
    name: 'help'
  }
</script>
